import { getTimeuuid } from "./util";
import { selectIsLoaded, selectSelectedTestStations, selectTimeuuid } from "./selectors";
import { cacheDefaultTestStations, cacheServerTestStations, clear, setDefaultTestStations, setIsLoaded, setIsLoading, setIsSaving, setTestStations, setTimeuuid } from "./testStations";
import { downloadTestStations, uploadTestStations } from "./api";

export const thunkLoad = () => async (dispatch) => {
	dispatch(clear());
	dispatch(setIsLoading(true));

	const { testStations, empty } = await downloadTestStations(getTimeuuid());
	if (empty) {
		dispatch(setDefaultTestStations());
	} else { 
		dispatch(setTestStations(testStations));
	}
	dispatch(cacheDefaultTestStations());
	dispatch(cacheServerTestStations(testStations || []));
	dispatch(setIsLoaded(true));
	dispatch(setIsLoading(false));
};

export const thunkLoadIfNotLoaded = () => (dispatch, getState) => { 
	const isLoaded = selectIsLoaded(getState());
	const isLoading = selectIsLoaded(getState());
	if (!isLoaded && !isLoading) {
		dispatch(thunkLoad());
	}
}

export const thunkSaveTestStations = () => async (dispatch, getState) => {
	const timeuuid = getTimeuuid();
	const testStations = selectSelectedTestStations(getState());
	dispatch(setTimeuuid(timeuuid));
	dispatch(setIsSaving(true));

	await uploadTestStations(timeuuid, testStations);
	dispatch(thunkLoad());
}
